import * as Core from '../store/core';
import * as Initialisation from '../store/initialisation';
import * as Options from '../store/options';
import { useDispatch } from '../store/redux';
import * as Selections from '../store/selections';

export const useInitialiseInspirationFromRemoveParts = () => {
    const dispatch = useDispatch();

    return async (
        productId: string | undefined,
    ) => {
        // if the starting product id is undefined, we stay in Configuration and log the error.
        if (!productId) {
            dispatch(
                Core.error({
                    message: `no starting product id, could not go back to inspiration`,
                    context: {
                        type: 'log',
                    },
                }),
            );
            return;
        }

        // initialise inspiration state
        dispatch(Initialisation.resetConfiguration());
        // reset options state to initial
        dispatch(Options.reset());

        // initialise selections state, dependent on whether we have variants (conspiration) or not
        dispatch(Selections.reset());
    };
};
